class WorkTeamCardController {

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
    };
  }

  monthComparator(month1, month2) {
    if(month1.value < 4 && month2.value > 9) {
      return -1;
    }
    if(month1.value > 9 && month2.value < 4) {
      return 1;
    }
    return month1.value > month2.value ? -1 : 1;
  }
}

export default WorkTeamCardController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/workTeamList/workTeamCard/workTeamCard.controller.js